import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabservice() {



    const cardData = {




keyword: "One Way Cab Service",

headingDescription: "Shreesha Tours & Travels provides reliable, affordable, and convenient One Way Cab Services for travelers looking for comfortable intercity and outstation transportation without paying round-trip charges. We offer one-way taxi services for business travel, airport transfers, family visits, corporate travel, sightseeing, pilgrimage tours, and long-distance journeys across Maharashtra, Karnataka, Goa, Gujarat, Rajasthan, Madhya Pradesh, and many other destinations across India. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for solo travelers, families, corporate clients, and large groups. With experienced chauffeurs, doorstep pickup, transparent pricing, flexible pickup schedules, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free travel experience. Whether you need a one-way cab from Mumbai to another city or between major destinations across India, our professional drivers and well-maintained vehicles guarantee a smooth, punctual, and enjoyable journey every time.",

topPlaces: [
  {
    title: "Pune",
    description: "Pune is one of the most frequently booked one-way cab destinations from Mumbai, known for its IT parks, educational institutions, business hubs, historical monuments, and vibrant lifestyle. It is ideal for corporate travel, family visits, and airport transfers."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station offering beautiful valleys, waterfalls, Tiger Point, Bhushi Dam, and pleasant weather. It is one of the top one-way cab routes for weekend holidays and sightseeing trips."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most important pilgrimage destinations, attracting millions of devotees visiting the sacred Shri Sai Baba Samadhi Mandir. One-way cab services are highly preferred for comfortable religious travel."
  },
  {
    title: "Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and the Godavari River. It is a popular one-way travel destination for religious, business, and leisure trips."
  },
  {
    title: "Goa",
    description: "Goa is India's leading beach destination, known for beautiful beaches, Portuguese heritage, nightlife, churches, forts, water sports, and luxury resorts. It is among the most booked long-distance one-way cab destinations."
  },
  {
    title: "Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial hub, known for Sabarmati Ashram, Kankaria Lake, Adalaj Stepwell, textile markets, and corporate business centers. It is a popular route for business and family travel."
  },
  {
    title: "Surat",
    description: "Surat is a major textile and diamond business city, frequently visited for corporate meetings, industrial visits, shopping, and family travel. One-way cab services offer a convenient travel option between Mumbai and Surat."
  },
  {
    title: "Indore",
    description: "Indore is Madhya Pradesh's commercial capital, famous for Rajwada Palace, Sarafa Night Market, Khajrana Ganesh Temple, and nearby Ujjain and Omkareshwar. It is a preferred destination for business and pilgrimage travelers."
  },
  {
    title: "Bangalore",
    description: "Bangalore is India's leading IT city, home to multinational companies, technology parks, educational institutions, and major business centers. Long-distance one-way cab services are popular among corporate travelers and families."
  },
  {
    title: "Jaipur",
    description: "Jaipur, the Pink City of Rajasthan, is renowned for Amber Fort, Hawa Mahal, City Palace, Jantar Mantar, and vibrant cultural heritage. It is one of the most sought-after destinations for tourism and family vacations."
  }
],



"services": [
  {
    "name": "One Way Cab Service",
    "description": "Book One Way Cab Service for safe, comfortable, and affordable single-trip travel without paying return charges. Choose from Sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller vehicles with professional chauffeurs for airport transfers, business travel, family trips, and long-distance outstation journeys across Maharashtra and India."
  },
  {
    "name": "One Way Taxi Service",
    "description": "Choose One Way Taxi Service for convenient point-to-point transportation with experienced drivers, clean AC vehicles, and transparent pricing. Enjoy reliable pickup, comfortable travel, and flexible drop locations for personal, business, and leisure travel."
  },
  {
    "name": "One Way Cab Booking",
    "description": "Complete One Way Cab Booking with instant confirmation, competitive fares, and multiple vehicle options. Reserve your preferred cab online for local, airport, and outstation travel with professional chauffeur service and hassle-free booking."
  },
  {
    "name": "One Way Taxi Booking",
    "description": "Reserve One Way Taxi Booking for reliable chauffeur-driven transportation with affordable pricing and well-maintained vehicles. Enjoy doorstep pickup, flexible schedules, and comfortable one way travel for every destination."
  },
  {
    "name": "Mumbai One Way Cab Service",
    "description": "Book Mumbai One Way Cab Service for affordable intercity and outstation travel from Mumbai to destinations across Maharashtra, Goa, Gujarat, Karnataka, and nearby states. Travel comfortably with Sedan, Ertiga, Innova Crysta, SUVs, and professional drivers without paying unnecessary return fares."
  },
  {
    "name": "Mumbai One Way Taxi",
    "description": "Choose Mumbai One Way Taxi for comfortable one-direction travel with experienced chauffeurs, clean AC vehicles, and transparent pricing. Ideal for airport transfers, business trips, family travel, and long-distance transportation."
  },
  {
    "name": "One Way Outstation Cab",
    "description": "Hire One Way Outstation Cab for safe and economical intercity travel with flexible pickup and drop locations. Enjoy reliable transportation, premium vehicles, and professional drivers for business visits, vacations, pilgrimages, and family trips."
  },
  {
    "name": "One Way Car Rental Service",
    "description": "Book One Way Car Rental Service with chauffeur-driven vehicles for comfortable and hassle-free single-trip travel. Select from a wide range of cars including Sedan, Ertiga, Innova Crysta, SUVs, and Tempo Travellers according to your travel requirements."
  },
  {
    "name": "One Way Drop Taxi Service",
    "description": "Reserve One Way Drop Taxi Service for convenient door-to-door transportation with fixed pricing and reliable chauffeur service. Perfect for airport transfers, hotel drops, office travel, outstation journeys, and personal travel requirements."
  },
  {
    "name": "One Way Airport Cab Service",
    "description": "Book One Way Airport Cab Service for timely airport pickup and drop with professional chauffeurs, flight tracking, and comfortable AC vehicles. Enjoy stress-free transportation to and from airports with reliable service and affordable fares."
  },
  {
    "name": "One Way Private Taxi",
    "description": "Choose One Way Private Taxi for personalized travel with dedicated chauffeur-driven vehicles offering complete privacy, comfort, and flexibility. Ideal for business executives, families, tourists, and long-distance travelers."
  },
  {
    "name": "Affordable One Way Cab Service",
    "description": "Hire Affordable One Way Cab Service for budget-friendly transportation without compromising safety or comfort. Enjoy competitive fares, experienced drivers, clean vehicles, and dependable travel solutions for one way local and outstation journeys."
  },
  {
    "name": "One Way Cab Near Me",
    "description": "Find One Way Cab Near Me for quick and reliable cab availability with instant booking, professional drivers, and doorstep pickup. Travel comfortably anytime with well-maintained AC vehicles and flexible travel options."
  },
  {
    "name": "One Way Taxi Fare",
    "description": "Check One Way Taxi Fare with transparent pricing, affordable travel packages, and no hidden charges. Get reliable one way taxi services with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options for comfortable and economical travel."
  }
],
"tableData": [
  ["One Way Cab Service", "One Way Taxi Service"],
  ["One Way Cab Booking", "One Way Taxi Booking"],
  ["Mumbai One Way Cab Service", "Mumbai One Way Taxi"],
  ["One Way Outstation Cab", "One Way Car Rental Service"],
  ["One Way Drop Taxi Service", "One Way Airport Cab Service"],
  ["One Way Private Taxi", "Affordable One Way Cab Service"],
  ["One Way Cab Near Me", "One Way Taxi Fare"]
],




whychoose: [
  {
    WhyChooseheading: "Convenient One Way Cab Service for Every Destination",
    WhyChoosedescription: "Travel comfortably with Shreesha Tours & Travels by choosing our one way cab service for airport transfers, city travel, outstation journeys, business trips, family visits, and interstate travel without paying for a return journey."
  },
  {
    WhyChooseheading: "Travel Only for the Distance You Need",
    WhyChoosedescription: "Our one way taxi service is an ideal option for travellers who require transportation to a single destination with flexible pickup timings and direct drop-off."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses according to your travel requirements and group size."
  },
  {
    WhyChooseheading: "Perfect for Business, Family & Airport Transfers",
    WhyChoosedescription: "Whether you're travelling for office work, airport transfers, vacations, weddings, medical appointments, or personal visits, our one way cab service offers a reliable travel solution."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe & Comfortable Travel",
    WhyChoosedescription: "Our experienced chauffeurs ensure punctual pickups, smooth highway driving, and a pleasant journey while maintaining high standards of safety and professionalism."
  },
  {
    WhyChooseheading: "Available for Local & Outstation Routes",
    WhyChoosedescription: "Book one way cabs for local city rides, airport transfers, intercity travel, and long-distance destinations across Maharashtra, Gujarat, Goa, Karnataka, Rajasthan, Madhya Pradesh, and many other states."
  },
  {
    WhyChooseheading: "Simple Booking with Transparent Pricing",
    WhyChoosedescription: "Receive clear fare details, quick booking confirmation, and dedicated customer support without complicated booking procedures."
  },
  {
    WhyChooseheading: "Trusted One Way Taxi Service by Shreesha Tours & Travels",
    WhyChoosedescription: "With comfortable vehicles, dependable service, and flexible travel options, we make one way cab bookings convenient for individuals, families, and corporate travellers."
  }
]

};

const faqData = [
  {
    question: "What is a one way cab service?",
    answer: "A one way cab service allows you to travel from your pickup location to your destination without booking a return journey."
  },
  {
    question: "Can I book a one way taxi for outstation travel?",
    answer: "Yes, one way taxi services are available for outstation routes, interstate travel, airport transfers, and city-to-city journeys."
  },
  {
    question: "Which vehicles are available for one way cab booking?",
    answer: "You can choose Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses."
  },
  {
    question: "Is one way cab service available for airport transfers?",
    answer: "Yes, we provide one way airport pickup and drop services for both domestic and international terminals."
  },
  {
    question: "Can I book a one way taxi for corporate travel?",
    answer: "Yes, our service is suitable for business executives, employees, client visits, conferences, and official travel."
  },
  {
    question: "Do you provide doorstep pickup and drop?",
    answer: "Yes, we offer pickup and drop services from homes, hotels, offices, airports, railway stations, and other preferred locations."
  },
  {
    question: "How is the one way cab fare calculated?",
    answer: "The fare depends on the travel distance, selected vehicle category, destination, route, and travel schedule."
  },
  {
    question: "Can I schedule my one way taxi in advance?",
    answer: "Yes, advance booking is recommended to ensure your preferred vehicle is available on your travel date."
  },
  {
    question: "Is one way cab service available every day?",
    answer: "Yes, one way taxi bookings are available throughout the year, subject to vehicle availability."
  },
  {
    question: "How can I book a One Way Cab Service with Shreesha Tours & Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback: "I booked a one way cab for an outstation business trip with Shreesha Tours & Travels. The driver arrived on time, the vehicle was clean, and the journey was comfortable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patwardhan",
    feedback: "Our family used the one way taxi service for airport travel. The booking was simple, the fare was transparent, and the overall experience was smooth and reliable.",
    rating: 5
  }
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Service",
  "image": "https://www.shreeshatravels.com/assets/images/one-way-cab-service.webp",
  "description":
    "Book One Way Cab Service with Shreesha Tours & Travels for safe, comfortable, and affordable intercity taxi services. We provide one-way cab bookings from Mumbai to destinations across Maharashtra and India with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for airport transfers, business travel, family trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/one-way-cab-service"
  }
};







    return (
        <div>
<Helmet>
  <title>One Way Cab Service | Affordable Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book One Way Cab Service with Shreesha Travels for reliable one-way taxi services from Mumbai. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable intercity travel with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="One Way Cab Service, One Way Taxi Service, One Way Cab Booking, One Way Taxi Booking, Mumbai One Way Cab, Mumbai One Way Taxi, One Way Outstation Cab, Intercity One Way Cab, Affordable One Way Taxi, Online One Way Cab Booking, One Way Innova Cab, One Way Sedan Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onewaycabservice;